import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { PatientAuthContext } from "../../contexts/PatientAuthContext";

const MenuItems = (props) => {
  const { isMobileMenu } = props;
  const navigate = useNavigate();
  const { patient } = useContext(PatientAuthContext);
  const [home, setHome] = useState(false);
  const [about, setAbout] = useState(false);
  const [online, setOnline] = useState(false);
  const [joinUs, setJoinUs] = useState(false);
  const [research, setResearch] = useState(false);
  const [researchDept, setResearchDept] = useState(false);
  const [irb, setIrb] = useState(false);
  const [academic, setAcademic] = useState(false);
  const [service, setService] = useState(false);
  const [page, setPage] = useState(false);
  const [shop, setShop] = useState(false);
  const [blog, setBlog] = useState(false);

  const openMobileMenu = (menu) => {
    if (menu === "home") {
      setHome(!home);
      setAbout(false);
      setService(false);
      setPage(false);
      setShop(false);
      setBlog(false);
    } else if (menu === "about") {
      setHome(false);
      setAbout(!about);
      setOnline(false);
      setService(false);
      setPage(false);
      setShop(false);
      setBlog(false);
    } else if (menu === "online") {
      setHome(false);
      setAbout(false);
      setOnline(!online);
      setJoinUs(false);
      setService(false);
      setPage(false);
      setShop(false);
      setBlog(false);
    } else if (menu === "joinUs") {
      setHome(false);
      setAbout(false);
      setOnline(false);
      setJoinUs(!joinUs);
      setResearch(false);
      setResearchDept(false);
      setIrb(false);
      setAcademic(false);
      setService(false);
      setPage(false);
      setShop(false);
      setBlog(false);
    } else if (menu === "research") {
      setHome(false);
      setAbout(false);
      setOnline(false);
      setJoinUs(false);
      setResearch(!research);
      setResearchDept(false);
      setIrb(false);
      setAcademic(false);
      setService(false);
      setPage(false);
      setShop(false);
      setBlog(false);
    } else if (menu === "researchDept") {
      setResearchDept(!researchDept);
      setIrb(false);
      setAcademic(false);
    } else if (menu === "irb") {
      setResearchDept(false);
      setIrb(!irb);
      setAcademic(false);
    } else if (menu === "academic") {
      setResearchDept(false);
      setIrb(false);
      setAcademic(!academic);
    } else if (menu === "service") {
      setHome(false);
      setAbout(false);
      setOnline(false);
      setJoinUs(false);
      setResearch(false);
      setResearchDept(false);
      setIrb(false);
      setAcademic(false);
      setService(!service);
      setPage(false);
      setShop(false);
      setBlog(false);
    } else if (menu === "page") {
      setHome(false);
      setAbout(false);
      setOnline(false);
      setJoinUs(false);
      setResearch(false);
      setResearchDept(false);
      setIrb(false);
      setAcademic(false);
      setService(false);
      setPage(!page);
      setShop(false);
      setBlog(false);
    } else if (menu === "shop") {
      setHome(false);
      setAbout(false);
      setOnline(false);
      setJoinUs(false);
      setResearch(false);
      setResearchDept(false);
      setIrb(false);
      setAcademic(false);
      setService(false);
      setPage(false);
      setShop(!shop);
      setBlog(false);
    } else if (menu === "blog") {
      setHome(false);
      setAbout(false);
      setOnline(false);
      setJoinUs(false);
      setResearch(false);
      setResearchDept(false);
      setIrb(false);
      setAcademic(false);
      setService(false);
      setPage(false);
      setShop(false);
      setBlog(!blog);
    }
  };

  const handleClick = (e) => {
    if (isMobileMenu === true) {
      e.preventDefault();
    }
  };

  return (
    <ul>
      <li>
        <Link to="/">Home</Link>
      </li>
      <li className="has-dropdown">
        <Link to="/about-us" className={about ? "expanded" : ""} onClick={handleClick}>
          About Us
          <button
            className={`${about ? "dropdown-toggle-btn dropdown-opened" : "dropdown-toggle-btn"} d-xl-none `}
            onClick={() => {
              openMobileMenu("about");
            }}
          >
            <i className="fal fa-angle-right"></i>
          </button>
        </Link>
        <ul className={about ? "it-submenu submenu d-block" : "it-submenu submenu"}>
          <li>
            <Link to="/about-us#our-story">Our Story</Link>
          </li>
          <li>
            <Link to="/about-us#chairman-message">Chairman Message</Link>
          </li>
          <li>
            <Link to="/about-us#ceo-message">CEO Message</Link>
          </li>
          <li>
            <Link to="/about-us#vision-mission">Our Vision / Mission</Link>
          </li>
          <li>
            <Link to="/about-us#our-team">Our Team</Link>
          </li>
          <li>
            <Link to="/about-us#our-doctors">Our Doctors</Link>
          </li>
          <li>
            <Link to="/about-us#testimonials">Testimonials</Link>
          </li>
          <li>
            <Link to="/about-us#faqs">FAQs</Link>
          </li>
        </ul>
      </li>
      <li>
        <Link to="/departments">Departments</Link>
      </li>
      <li>
        <Link to="/contact">Contact Us</Link>
      </li>
      <li className="has-dropdown">
        <Link to="#" className={online ? "expanded" : ""} onClick={handleClick}>
          Online Services
          <button
            className={`${online ? "dropdown-toggle-btn dropdown-opened" : "dropdown-toggle-btn"} d-xl-none `}
            onClick={() => {
              openMobileMenu("online");
            }}
          >
            <i className="fal fa-angle-right"></i>
          </button>
        </Link>
        <ul className={online ? "it-submenu submenu d-block" : "it-submenu submenu"}>
          <li>
            <Link to="/e-services">E-Services</Link>
          </li>
          <li>
            <Link to="/appointment">Request an Appointment</Link>
          </li>
          <li>
            <a href="http://reports.maroof.com.pk/online/downloadreports/" target="_blank" rel="noopener noreferrer">
              Online Reports
            </a>
          </li>
          {patient && (
            <li>
              <Link to="/my-appointments">My Appointments</Link>
            </li>
          )}
          {patient && (
            <li>
              <Link to="/my-reports">My Reports</Link>
            </li>
          )}
        </ul>
      </li>
      <li className="has-dropdown">
        <Link to="#" className={joinUs ? "expanded" : ""} onClick={handleClick}>
          Join Us
          <button
            className={`${joinUs ? "dropdown-toggle-btn dropdown-opened" : "dropdown-toggle-btn"} d-xl-none `}
            onClick={() => {
              openMobileMenu("joinUs");
            }}
          >
            <i className="fal fa-angle-right"></i>
          </button>
        </Link>
        <ul className={joinUs ? "it-submenu submenu d-block" : "it-submenu submenu"}>
          <li>
            <Link to="/careers">Careers</Link>
          </li>
          <li>
            <Link to="/internship-observership">Internship / Observership</Link>
          </li>
        </ul>
      </li>
      <li className="research-cta-li">
        <button
          className="ma-btn-primary"
          style={{ borderRadius: 8, fontSize: ".875rem", padding: "10px 20px", cursor: "pointer" }}
          onClick={() => navigate("/research")}
        >
          <i className="fa-regular fa-triangle-exclamation" style={{ marginRight: 7 }}></i>
          Research & Clinical Trials
        </button>
        {/* <Link to="/research" className="research-cta-btn">
          <span className="research-cta-glow"></span>
          <span className="research-cta-icon">
            <i className="fa-regular fa-flask-vial"></i>
          </span>
          <span className="research-cta-text">
            <span className="research-cta-label">Research & Clinical Trials</span>
          </span>
          <span className="research-cta-arrow">
            <i className="fa-regular fa-arrow-right"></i>
          </span>
        </Link> */}
      </li>
    </ul>
  );
};

export default MenuItems;
